export const createFactboxProps = props => {

  const {
    riskArea,
    riskWeight,
    titleRiskArea,
    riskAreaRest,
    riskWeightRest,
    titleRiskAreaRest,
    numberOfChecklistItems
  } = props;

  const badgePropsRiskArea = {
    title: riskArea ? titleRiskArea : undefined,
    tooltip: riskArea ? riskArea.description : undefined,
    text: !props.hideRiskWeight ? riskWeight : '',
    filled: true,
    backgroundColor: riskArea ? riskArea.backgroundColor : undefined,
    foregroundColor: riskArea ? riskArea.foregroundColor : undefined
  };

  const badgePropsRiskAreaRest = {
    title: riskAreaRest ? titleRiskAreaRest : undefined,
    tooltip: riskAreaRest ? riskAreaRest.description : undefined,
    text: !props.hideRiskWeight ? riskWeightRest : '',
    filled: false,
    backgroundColor: (!!riskAreaRest && !!riskAreaRest.value && riskAreaRest.backgroundColor) ? riskAreaRest.backgroundColor : undefined
  };

  const numberOfActions =
    props.numberOfActions ? props.numberOfActions.count : 0;

  const numberOfAttachments =
    (props.numberOfFiles && props.numberOfFiles.count) +
    (props.numberOfLinks && props.numberOfLinks.count);

  const numberOfConnectedCases =
    (props.connectedCasesIds && props.connectedCasesIds.length);

  const numberOfComments =
    (props.numberOfComments && props.numberOfComments.count) || 0;

  const numberOfCauses =
    (props.numberOfCauses && props.numberOfCauses.count) || 0;

  const numberOfInvolvedPersons =
    (props.numberOfInvolvedPersons &&
      props.numberOfInvolvedPersons.count) ||
    0;

  const numberOfConsequences =
    (props.childValueItems &&
      props.childValueItems.ActConsConsequenceIcons.length) ||
    0;

  const numberOfInvolvedDrugs =
    (props.numberOfInvolvedDrugs &&
      props.numberOfInvolvedDrugs.count) ||
    0;

  const numberOfAssessments =
    (props.numberOfAssessments &&
      props.numberOfAssessments.count) ||
    0;

  // Used to hide empty factboxes using css
  const numberOfFiles =
    (props.numberOfFiles && props.numberOfFiles.count) || 0;

  const totalsExceptActions =
    numberOfFiles +
    numberOfAttachments +
    numberOfCauses +
    numberOfComments +
    numberOfInvolvedPersons +
    numberOfConnectedCases +
    numberOfConsequences +
    numberOfInvolvedPersons;

    return {
      badgePropsRiskArea,
      badgePropsRiskAreaRest,
      totalsExceptActions,
      numberOfActions,
      numberOfAssessments,
      numberOfAttachments,
      numberOfCauses,
      numberOfChecklistItems,
      numberOfComments,
      numberOfConnectedCases,
      numberOfConsequences,
      numberOfFiles,
      numberOfInvolvedDrugs,
      numberOfInvolvedPersons
    };
};
